export default "__VITE_ASSET__CoIsxeB1__"